var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisclaimerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 7C0.25 4.1877 0.25 2.78155 0.966186 1.79581C1.19748 1.47745 1.47745 1.19748 1.79581 0.966186C2.78155 0.25 4.1877 0.25 7 0.25C9.8123 0.25 11.2184 0.25 12.2042 0.966186C12.5225 1.19748 12.8025 1.47745 13.0338 1.79581C13.75 2.78155 13.75 4.1877 13.75 7C13.75 9.8123 13.75 11.2184 13.0338 12.2042C12.8025 12.5225 12.5225 12.8025 12.2042 13.0338C11.2184 13.75 9.8123 13.75 7 13.75C4.1877 13.75 2.78155 13.75 1.79581 13.0338C1.47745 12.8025 1.19748 12.5225 0.966186 12.2042C0.25 11.2184 0.25 9.8123 0.25 7ZM7 5.6875C7.31066 5.6875 7.5625 5.93934 7.5625 6.25V10.75C7.5625 11.0607 7.31066 11.3125 7 11.3125C6.68934 11.3125 6.4375 11.0607 6.4375 10.75V6.25C6.4375 5.93934 6.68934 5.6875 7 5.6875ZM7 4.75C7.41421 4.75 7.75 4.41421 7.75 4C7.75 3.58579 7.41421 3.25 7 3.25C6.58579 3.25 6.25 3.58579 6.25 4C6.25 4.41421 6.58579 4.75 7 4.75Z",
    fill: "#020808"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisclaimerIcon);
export default __webpack_public_path__ + "static/media/disclaimerIcon.1b69b88a999b911fd4507a6420cd7bfb.svg";
export { ForwardRef as ReactComponent };